'use client'

import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useProductStock } from 'product/services/productStock/client'
import type { Stock } from 'product/types/Stock'

export const useGetProductStock = (
	productId: string
): {
	productStock: Stock | undefined
	isLoading: boolean
	error: Error
} => {
	const { country } = useMasterData()
	const {
		data: stock,
		isLoading,
		error,
	} = useProductStock({
		productId,
		country: country.countryISO,
		enabled: !!productId,
	})

	return {
		error,
		isLoading,
		productStock: stock,
	}
}
